// Minnesotaänger Mini App — message adapter.
// Maps the mini-app message contract (ApiMiniAppMessage) onto telegram-tt's
// ApiMessage so the restored Web A message-rendering chain
// (MessageList → groupMessages → MessageListContent → Message → Meta/Appendix)
// consumes it without any visual-component changes. `mini` carries the original
// record for context-menu actions (reroll/edit/delete) and the timestamp.
//
// senderId: 'user' for outgoing messages, the assistant id otherwise — so
// consecutive user messages group together and different personas split into
// their own sender groups (Web A grouping contract).

import type { ApiMessage } from '../types';
import type { ApiMiniAppMessage } from './types';

export type MiniAppMessage = ApiMessage & {
  mini: ApiMiniAppMessage;
};

export function miniAppMessageToApiMessage(miniMessage: ApiMiniAppMessage, chatId: string): MiniAppMessage {
  return {
    id: miniMessage.event_id,
    chatId,
    content: {
      text: {
        text: miniMessage.text,
      },
    },
    date: Math.floor(new Date(miniMessage.created_at).getTime() / 1000),
    isOutgoing: miniMessage.role === 'user',
    senderId: miniMessage.role === 'user' ? 'user' : (miniMessage.assistant_id ?? 'assistant'),
    mini: miniMessage,
  };
}

// --- Identity helpers (restored from Web A 4a2c0277 global/helpers/messages.ts,
// inlined here because v1 cut src/global/helpers/index.ts) ---

export function getMessageHtmlId(messageId: number | string, index?: number) {
  return ['message', messageId.toString().replace('.', '-'), index].filter(Boolean).join('-');
}

export function getMessageOriginalId(message: ApiMessage): number {
  return message.id;
}

export function isOwnMessage(message: ApiMessage) {
  return message.isOutgoing;
}

export function isActionMessage(message: ApiMessage) {
  return Boolean(message.content.action);
}
